module.exports = __webpack_public_path__ + "img/bp_giftbg_0003.92fa14db.png";